import React, { useEffect, useMemo } from "react";
import QRCode from "qrcode.react";

import api from "../../../services/api";
import toastError from "../../../errors/toastError";

// Renderiza o QR do whatsapp-web.js (mesma lib do QrcodeModal original).
const QrRender = ({ value }) => {
  if (!value) {
    return (
      <div
        style={{
          width: 208,
          height: 208,
          borderRadius: 8,
          background: "#F2F2F2",
        }}
      />
    );
  }
  return <QRCode value={value} size={208} level="L" includeMargin={false} />;
};

// Modal "Conectar celular". useWhatsApps traz status+qrcode via socket. PUT em
// /whatsappsession/:id (re)gera o QR. Fecha sozinho quando o whatsapp conecta.
const QrModal = ({ V, open, whatsapp, onClose }) => {
  const status = whatsapp?.status;
  const qrcode = whatsapp?.qrcode;

  const connected = status === "CONNECTED";

  useEffect(() => {
    if (open && connected) {
      onClose();
    }
  }, [open, connected, onClose]);

  const generate = useMemo(
    () => async () => {
      if (!whatsapp?.id) return;
      try {
        await api.put(`/whatsappsession/${whatsapp.id}`);
      } catch (err) {
        toastError(err);
      }
    },
    [whatsapp],
  );

  // Ao abrir, se não estiver conectado e sem QR ainda, dispara a sessão.
  useEffect(() => {
    if (open && whatsapp?.id && !connected && !qrcode) {
      generate();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open, whatsapp?.id]);

  if (!open) return null;

  const funnel = V.key === "b";

  return (
    <div
      style={{
        position: "absolute",
        inset: 0,
        background: "rgba(46,37,24,.5)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        zIndex: 30,
      }}
    >
      <div
        style={{
          background: "#fff",
          borderRadius: V.qrModalRadius,
          padding: "24px 28px",
          width: 610,
          display: "flex",
          gap: 26,
          alignItems: "center",
          boxShadow: "0 20px 60px rgba(0,0,0,.25)",
        }}
      >
        <div
          style={{
            flex: 1,
            display: "flex",
            flexDirection: "column",
            gap: 10,
          }}
        >
          <div style={{ fontSize: 17, fontWeight: 900, color: V.textStrong }}>
            Conectar celular
          </div>
          <div style={{ fontSize: 12.5, color: V.sublabel, lineHeight: 1.5 }}>
            Escaneie o QR code para conectar o WhatsApp desta fila ao CRM.
          </div>
          <ol
            style={{
              margin: 0,
              paddingLeft: 18,
              display: "flex",
              flexDirection: "column",
              gap: 6,
              fontSize: 12.5,
              color: V.sublabel,
              lineHeight: 1.4,
            }}
          >
            <li>Abra o WhatsApp no seu celular</li>
            <li>
              Toque em <b>Mais opções</b> e em <b>Aparelhos conectados</b>
            </li>
            <li>
              Toque em <b>Conectar um aparelho</b>
            </li>
            <li>Aponte a câmera para este código</li>
          </ol>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: 8,
              marginTop: 2,
            }}
          >
            <span
              style={{
                display: "inline-flex",
                alignItems: "center",
                gap: 6,
                background: "#FFF3DC",
                color: "#B7791F",
                fontSize: 11,
                fontWeight: 800,
                padding: "3px 10px",
                borderRadius: funnel ? 6 : 999,
              }}
            >
              <span
                style={{
                  width: 7,
                  height: 7,
                  borderRadius: "50%",
                  background: "#F5A623",
                }}
              />
              {qrcode ? "Aguardando leitura…" : "Gerando código…"}
            </span>
          </div>
          <div style={{ display: "flex", gap: 8, marginTop: 4 }}>
            <button
              type="button"
              onClick={generate}
              style={{
                background: V.prim,
                border: "none",
                color: "#fff",
                borderRadius: V.btnRadius,
                padding: "8px 16px",
                fontWeight: 900,
                fontSize: 12,
                fontFamily: "inherit",
                cursor: "pointer",
              }}
            >
              Gerar novo código
            </button>
            <button
              type="button"
              onClick={onClose}
              style={{
                background: "#fff",
                border: "1px solid #E8DFCE",
                color: V.sublabel,
                borderRadius: V.btnRadius,
                padding: "8px 16px",
                fontWeight: 800,
                fontSize: 12,
                fontFamily: "inherit",
                cursor: "pointer",
              }}
            >
              Fechar
            </button>
          </div>
        </div>
        <div
          style={{
            flex: "none",
            background: "#fff",
            border: "1px solid #EEE4D2",
            borderRadius: 16,
            padding: 10,
          }}
        >
          <div
            style={{
              width: 208,
              height: 208,
              borderRadius: 8,
              overflow: "hidden",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              background: "#fff",
            }}
          >
            <QrRender value={qrcode} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default QrModal;
